import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import styled from 'styled-components';
import useSWR from 'swr';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import Loading from '../../../common/base/Loading';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { EmptyResults, StyledEmptyStateWrapper } from '../../../common/EmptyState';
const StyledEmptyView = styled.div`
  flex-grow: 1;
  max-width: 480px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const BookmarksListEmptyView: React.FC = () => {
  const $ = _c(5);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = APIMethodKeys.bookmarks.list({
      limit: 1
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== HookdeckAPI.bookmarks) {
    t1 = () => HookdeckAPI.bookmarks.list({
      limit: 1
    });
    $[1] = HookdeckAPI.bookmarks;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: entries
  } = useSWR(t0, t1);
  if (!entries) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <StyledEmptyView><Loading /></StyledEmptyView>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <StyledEmptyStateWrapper><EmptyResults label="No bookmarks found" /></StyledEmptyStateWrapper>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default BookmarksListEmptyView;